module.exports = __webpack_public_path__ + "img/block_1.e65c16fa.webp";